// Exercises API — catalog search/filter, detail, custom create, favorites.
import { http } from "./http";
import type {
  CustomExerciseInput,
  Exercise,
  ExerciseFilter,
  OkResponse,
} from "./types";

export const exercisesApi = {
  list: (filter: ExerciseFilter = {}, signal?: AbortSignal) =>
    http.get<Exercise[]>("/exercises", filter, signal),
  get: (id: number, signal?: AbortSignal) =>
    http.get<Exercise>(`/exercises/${id}`, undefined, signal),
  createCustom: (body: CustomExerciseInput) =>
    http.post<Exercise>("/exercises", body),

  listFavorites: (signal?: AbortSignal) =>
    http.get<Exercise[]>("/favorites", undefined, signal),
  addFavorite: (exerciseId: number) =>
    http.post<OkResponse>(`/favorites/${exerciseId}`),
  removeFavorite: (exerciseId: number) =>
    http.del<OkResponse>(`/favorites/${exerciseId}`),
};
